export const adaptFrecuenciasDistribuidor = (frecuenciaDistribuidorData) => {

    const loadLocalidades = (frecuenciaDistribuidorCP) => {

        let listado = frecuenciaDistribuidorCP?.map((localidad) => {
            return localidad.idCodigoPostalNavigation?.localidad
        });

        return listado;
    }

    return {
        id: frecuenciaDistribuidorData?.idFrecuenciaDistribuidor,
        idProveedorDistribuidor: frecuenciaDistribuidorData?.idProveedorDistribuidor,  
        idDeposito : frecuenciaDistribuidorData?.idDeposito,
        activo : frecuenciaDistribuidorData?.activo,
        deposito: frecuenciaDistribuidorData?.idDepositoNavigation?.descripcion,
        distribuidor: frecuenciaDistribuidorData?.idProveedorDistribuidorNavigation?.razonSocial,
        codigoPostal: frecuenciaDistribuidorData?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.cP,
        provincia: frecuenciaDistribuidorData?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.idProvinciaNavigation?.descripcion,
        localidad: frecuenciaDistribuidorData?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.localidad,
        modoDespacho: frecuenciaDistribuidorData?.idFrecuenciaModoDespachoNavigation?.descripcion,
        localidades: loadLocalidades(frecuenciaDistribuidorData?.frecuenciaDistribuidorCP)
    }
}

export const adaptFrecuenciasDistribuidorArray = (
    frecuenciaDistribuidorData
) => {
    return structuredClone(frecuenciaDistribuidorData)
        ?.map(frecuencias => adaptFrecuenciasDistribuidor(frecuencias));
}